import URI from 'jsuri';

import { getPurchaseLink } from 'bundles/enterprise-legacy-learner-home/utils/programUrlUtils';

export const enterpriseContractBillingType = {
  NONE: 'NONE',
  INVOICE: 'INVOICE',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  ONE_TIME: 'ONE_TIME',
} as const;

export type EnterpriseContractBillingType =
  (typeof enterpriseContractBillingType)[keyof typeof enterpriseContractBillingType];

export const createCartFromCartItem = (
  userId: $TSFixMe,
  userName: $TSFixMe,
  cartItem: $TSFixMe,
  newOptions: $TSFixMe
) => {
  const { metadata } = cartItem.cartItem;
  const cartItemMetadata = metadata['org.coursera.payment.EnterpriseContractCartItemMetadata'];
  const {
    thirdPartyOrganizationId,
    billingType,
    organizationName,
    limits: { coursesPerUserLimit = -1, userLimit },
  } = cartItemMetadata;

  const newCoursesPerUserLimit = newOptions.coursesPerUserLimit || coursesPerUserLimit;
  return {
    userId,
    thirdPartyOrganizationId,
    billingType: newOptions.billingType || billingType,
    limits: {
      userLimit: newOptions.userLimit || userLimit,
      coursesPerUserLimit: newCoursesPerUserLimit.toString() === '-1' ? null : newCoursesPerUserLimit,
    },
    salesforceInfo: {
      userName,
      organizationName,
    },
  };
};

export const createUrlFromCartItem = (cartItem: $TSFixMe) => {
  const { metadata } = cartItem.cartItem;
  const cartItemMetadata = metadata['org.coursera.payment.EnterpriseContractCartItemMetadata'];
  const {
    thirdPartyOrganizationId,
    organizationName,
    limits: { coursesPerUserLimit, userLimit },
  } = cartItemMetadata;
  const uri = new URI(getPurchaseLink());
  // a null coursesPerUserLimit also means it's unlimited
  uri.addQueryParam('courseCount', coursesPerUserLimit || '-1');
  uri.addQueryParam('learnerCount', userLimit);
  if (thirdPartyOrganizationId) {
    uri.addQueryParam('thirdPartyOrganizationId', thirdPartyOrganizationId);
  } else {
    uri.addQueryParam('organizationName', encodeURI(organizationName));
  }
  return uri.toString();
};
